define("settings/components/cancel-plan/slide/reasons", ["exports", "@ember/component", "@ember/template-factory", "@ember/object", "@glimmer/component", "@glimmer/tracking"], function (_exports, _component, _templateFactory, _object, _component2, _tracking) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;

  var _class, _descriptor, _descriptor2;

  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@ember/object",0,"@glimmer/component",0,"@glimmer/tracking"eaimeta@70e063a35619d71f

  function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }

  function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

  function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

  function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'proposal-class-properties is enabled and runs after the decorators transform.'); }

  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    {{! @glint-nocheck: not typesafe yet }}
  {{! @glint-nocheck: not typesafe yet }}
  {{#if this.showDetails}}
    <Shared::Ui::Button @onClick={{this.onBack}} @variant="mute" class="tCA--backBtn">
      {{svg-jar "arrow-left" class="o--icon--sm tCA--backBtn__icon"}}
      {{t "shared_words.back"}}
    </Shared::Ui::Button>
  {{else}}
    {{#let (component @previousButton) as |PreviousButton|}}
      <PreviousButton buttonClass="tCA--backBtn" onClick={{this.onBack}}>
        {{svg-jar "arrow-left" class="o--icon--sm tCA--backBtn__icon"}}
        {{t "shared_words.back"}}
      </PreviousButton>
    {{/let}}
  {{/if}}
  
  <p class="tCA--title">
    {{#if @isSubQuestion}}
      {{t "account.change_plan.cancellation_feedback.subquestion_title"}}
    {{else}}
      {{t "account.change_plan.cancellation_feedback.question_title"}}
    {{/if}}
  </p>
  
  <p class="u--m__b__lg">{{@questionText}}</p>
  
  {{#if this.showDetails}}
    <textarea
      class="o--form__input"
      cols="50"
      id="other_textarea"
      oninput={{action (mut this.otherResponse) value="target.value"}}
      placeholder={{t "account.change_plan.cancellation_feedback.describe_details"}}
      rows="4"
    ></textarea>
    {{component
      @nextButton
      buttonClass="o--btn--lg o--btn--outline o--btn--block u--m__t"
      isDisabled=this.isOtherSubmitDisabled
      onClick=this.submitOtherResponse
      text=(t "account.change_plan.cancellation_feedback.submit")
    }}
  {{else}}
    {{#each (shuffle this.reasonsToRandomize) as |reason|}}
      {{component
        @nextButton
        buttonClass=(concat "o--btn--lg o--btn--outline o--btn--block u--text--hair qa--" reason.id)
        onClick=(fn @selectReason reason.id)
        text=reason.text
      }}
    {{/each}}
  
    {{#if this.otherOption}}
      <Shared::Ui::Button
        @additional="block"
        @size="large"
        @text={{this.otherOption.text}}
        @variant="outline"
        class="u--text--hair"
        {{on "click" this.selectOther}}
      />
    {{/if}}
  {{/if}}
  */
  {
    "id": "KPFJNjGj",
    "block": "[[[41,[30,0,[\"showDetails\"]],[[[1,\"  \"],[8,[39,1],[[24,0,\"tCA--backBtn\"]],[[\"@onClick\",\"@variant\"],[[30,0,[\"onBack\"]],\"mute\"]],[[\"default\"],[[[[1,\"\\n    \"],[1,[28,[35,2],[\"arrow-left\"],[[\"class\"],[\"o--icon--sm tCA--backBtn__icon\"]]]],[1,\"\\n    \"],[1,[28,[35,3],[\"shared_words.back\"],null]],[1,\"\\n  \"]],[]]]]],[1,\"\\n\"]],[]],[[[44,[[50,[30,1],0,null,null]],[[[1,\"    \"],[8,[30,2],[[24,\"buttonClass\",\"tCA--backBtn\"],[16,\"onClick\",[30,0,[\"onBack\"]]]],null,[[\"default\"],[[[[1,\"\\n      \"],[1,[28,[35,2],[\"arrow-left\"],[[\"class\"],[\"o--icon--sm tCA--backBtn__icon\"]]]],[1,\"\\n      \"],[1,[28,[35,3],[\"shared_words.back\"],null]],[1,\"\\n    \"]],[]]]]],[1,\"\\n\"]],[2]]]],[]]],[1,\"\\n\"],[10,2],[14,0,\"tCA--title\"],[12],[1,\"\\n\"],[41,[30,3],[[[1,\"    \"],[1,[28,[35,3],[\"account.change_plan.cancellation_feedback.subquestion_title\"],null]],[1,\"\\n\"]],[]],[[[1,\"    \"],[1,[28,[35,3],[\"account.change_plan.cancellation_feedback.question_title\"],null]],[1,\"\\n\"]],[]]],[13],[1,\"\\n\\n\"],[10,2],[14,0,\"u--m__b__lg\"],[12],[1,[30,4]],[13],[1,\"\\n\\n\"],[41,[30,0,[\"showDetails\"]],[[[1,\"  \"],[10,\"textarea\"],[14,0,\"o--form__input\"],[14,\"cols\",\"50\"],[14,1,\"other_textarea\"],[15,\"oninput\",[28,[37,6],[[30,0],[28,[37,7],[[30,0,[\"otherResponse\"]]],null]],[[\"value\"],[\"target.value\"]]]],[15,\"placeholder\",[28,[37,3],[\"account.change_plan.cancellation_feedback.describe_details\"],null]],[14,\"rows\",\"4\"],[12],[13],[1,\"\\n  \"],[46,[30,5],null,[[\"buttonClass\",\"isDisabled\",\"onClick\",\"text\"],[\"o--btn--lg o--btn--outline o--btn--block u--m__t\",[30,0,[\"isOtherSubmitDisabled\"]],[30,0,[\"submitOtherResponse\"]],[28,[37,3],[\"account.change_plan.cancellation_feedback.submit\"],null]]],null],[1,\"\\n\"]],[]],[[[42,[28,[37,9],[[28,[37,9],[[28,[37,10],[[30,0,[\"reasonsToRandomize\"]]],null]],null]],null],null,[[[1,\"    \"],[46,[30,5],null,[[\"buttonClass\",\"onClick\",\"text\"],[[28,[37,11],[\"o--btn--lg o--btn--outline o--btn--block u--text--hair qa--\",[30,6,[\"id\"]]],null],[28,[37,12],[[30,7],[30,6,[\"id\"]]],null],[30,6,[\"text\"]]]],null],[1,\"\\n\"]],[6]],null],[1,\"\\n\"],[41,[30,0,[\"otherOption\"]],[[[1,\"    \"],[8,[39,1],[[24,0,\"u--text--hair\"],[4,[38,13],[\"click\",[30,0,[\"selectOther\"]]],null]],[[\"@additional\",\"@size\",\"@text\",\"@variant\"],[\"block\",\"large\",[30,0,[\"otherOption\",\"text\"]],\"outline\"]],null],[1,\"\\n\"]],[]],null]],[]]]],[\"@previousButton\",\"PreviousButton\",\"@isSubQuestion\",\"@questionText\",\"@nextButton\",\"reason\",\"@selectReason\"],false,[\"if\",\"shared/ui/button\",\"svg-jar\",\"t\",\"let\",\"component\",\"action\",\"mut\",\"each\",\"-track-array\",\"shuffle\",\"concat\",\"fn\",\"on\"]]",
    "moduleName": "settings/components/cancel-plan/slide/reasons.hbs",
    "isStrictMode": false
  });

  let ReasonsComponent = (_class = class ReasonsComponent extends _component2.default {
    constructor() {
      super(...arguments);

      _initializerDefineProperty(this, "showDetails", _descriptor, this);

      _initializerDefineProperty(this, "otherResponse", _descriptor2, this);
    }

    get isOtherSubmitDisabled() {
      return this.otherResponse.length <= 0;
    }

    get reasonsToRandomize() {
      return this.args.reasons.filter(_ref => {
        let {
          id
        } = _ref;
        return id !== 'other';
      });
    }

    get otherOption() {
      return this.args.reasons.findBy('id', 'other');
    }

    onBack() {
      if (this.showDetails) {
        this.showDetails = false;
        this.otherResponse = '';
      } else if (this.args.clearReason) {
        this.args.clearReason();
      }
    }

    selectOther() {
      this.showDetails = true;
    }

    submitOtherResponse() {
      this.args.selectReason('other');
      this.args.submitOther(this.otherResponse);
    }

  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "showDetails", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return false;
    }
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "otherResponse", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return '';
    }
  }), _applyDecoratedDescriptor(_class.prototype, "onBack", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "onBack"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "selectOther", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "selectOther"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "submitOtherResponse", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "submitOtherResponse"), _class.prototype)), _class);
  _exports.default = ReasonsComponent;
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, ReasonsComponent);
});